// extracted by mini-css-extract-plugin
export var button = "CloseButton-module--button--cac78";
export var cross = "CloseButton-module--cross--542e9";
export var dark = "CloseButton-module--dark--11cf8";
export var light = "CloseButton-module--light--051b1";